const language = {
	'pt': {		
		birthday: 'Data de nascimento',
		name: 'Nome',
		morada: 'Morada',
		postal_code: 'Código-postal',
		local: 'Localidade',
		district: 'Estado / Distrito',
		country: 'País',
		email: 'E-mail',
		modalidades: 'Modalidades',
		escalao: 'Escalão',
		epoca: 'Época',
		clube: 'Clube',
		select: 'Selecione',

		// Identificação / documento
		tipo_documento: 'Tipo de documento',
		numero_documento: 'N.º de documento',
		validade: 'Validade',
		numero_contribuinte: 'N.º Contribuinte',
		numero_licenca: 'N.º Licença',

		// Função
		funcao: 'Função',
		arbitro_juiz: 'Árbitro/Juiz',
		director: 'Director',
		dirigente: 'Dirigente',
		praticante: 'Praticante',
		treinador: 'Treinador',
		colaborador: 'Colaborador',
		director_tecnico_nacional: 'Director Técnico Nacional',
		outros: 'Outros',
		seleccionador: 'Seleccionador',

		// Dados desportivos
		seguro_opcional: 'Seguro opcional',
		federado_outras_modalidades: 'Federado/a noutras modalidades? Se sim, indique quais',

		// Dados pessoais adicionais
		nacionalidade: 'Nacionalidade',
		naturalidade: 'Naturalidade',
		genero: 'Género',
		profissao: 'Profissão',
		profissao_placeholder: 'Se for estudante, preencha "Estudante"',
		estabelecimento_ensino: 'Estabelecimento de ensino',

		// Contactos
		contacto: 'Contacto',
		telefone: 'Telefone',
		tlm: 'Telemóvel',
		contacto_emergencia: 'Nome Contacto Emergência',
		nome_contacto_emergencia: 'Nome',
		parentesco: 'Parentesco',

		// Documentação / uploads
		fotografia: 'Fotografia',
		foto_dropzone: 'Arraste, para aqui, a sua fotografia, nos formatos JPG/JPEG, no máximo 1000kb. Em alternativa use o botão direito do rato para escolher o ficheiro',
		alterar_foto: 'Alterar fotografia',
		upload_image_error: 'Formato de imagem incorrecto: ',
		exame_medico: 'Exame Médico',
		pdf_dropzone: 'Arraste, para aqui, o seu exame médico em formato PDF, no máximo 1000kb. Em alternativa use o botão direito do rato para escolher o ficheiro',
		data_emissao_exame_medico: 'Data de Emissão do Exame Médico',

		// Pagamento
		inscricao: 'Inscrição',
		inscricao_subtitulo: 'Documentos obrigatórios para a inscrição: Foto em formato JPEG e Exame Médico em formato PDF!',
		total_a_pagar: 'Total a pagar',

		// Respostas sim/não
		sim: 'Sim',
		nao: 'Não',

		// Observações / consentimento / submissão
		observacoes_ice4all: 'Observações e situações especiais (ICE 4 ALL)',
		aceitacao_dados: 'A confirmação deste formulário implica a aceitação do processamento dos seus dados pessoais para fins da actividade desportiva da Federação.',
		revalidacao_aviso: 'Caso esteja a revalidar a sua inscrição numa nova época, ao inserir o seu número de documento, a maioria dos campos será, automaticamente, preenchida (podendo actualizar a informação que for necessária).',
		confirmar: 'Confirmar',
	},

	'en': {
		birthday: 'Date of Birth',
		name: 'Name',
		morada: 'Address',
		postal_code: 'Postal Code',
		local: 'Location',
		district: 'District',
		country: 'Country',
		email: 'Email',
		modalidades: 'Disciplines',
		escalao: 'Age Group',
		epoca: 'Season',
		clube: 'Club',
		select: 'Select',

		tipo_documento: 'Document type',
		numero_documento: 'Document number',
		validade: 'Validity',
		numero_contribuinte: 'Tax Number',
		numero_licenca: 'License Number',

		funcao: 'Role',
		arbitro_juiz: 'Referee/Judge',
		director: 'Director',
		dirigente: 'Official',
		praticante: 'Athlete',
		treinador: 'Coach',
		colaborador: 'Staff',
		director_tecnico_nacional: 'National Technical Director',
		outros: 'Other',
		seleccionador: 'Selector',

		seguro_opcional: 'Optional insurance',
		federado_outras_modalidades: 'Registered in other disciplines with other Federations? If so, please specify which',

		nacionalidade: 'Nationality',
		naturalidade: 'Place of birth',
		genero: 'Gender',
		profissao: 'Occupation',
		profissao_placeholder: 'If a student, fill in "Student"',
		estabelecimento_ensino: 'School/Institution',

		contacto: 'Contact',
		telefone: 'Phone',
		tlm: 'Mobile',
		contacto_emergencia: 'Emergency Contact Name',
		nome_contacto_emergencia: 'Name',
		parentesco: 'Relationship',

		fotografia: 'Photograph',
		foto_dropzone: 'Drag your photograph here, in JPG/JPEG format, max 1000kb. Alternatively, use the right mouse button to choose the file',
		alterar_foto: 'Change photograph',
		upload_image_error: 'Incorrect image format: ',
		exame_medico: 'Medical Exam',
		pdf_dropzone: 'Drag your medical exam here, in PDF format, max 1000kb. Alternatively, use the right mouse button to choose the file',
		data_emissao_exame_medico: 'Medical Exam Issue Date',

		inscricao: 'Registration',
		inscricao_subtitulo: 'Mandatory documents for registration: Photo in JPEG format and Medical Exam in PDF format!',
		total_a_pagar: 'Total to pay',

		sim: 'Yes',
		nao: 'No',

		observacoes_ice4all: 'Notes and special situations (ICE 4 ALL)',
		aceitacao_dados: 'Confirming this form implies acceptance of the processing of your personal data for the Federation\'s sporting activities.',
		revalidacao_aviso: 'If you are renewing your registration for a new season, entering your document number will automatically fill in most fields (you may update any information that needs changing).',
		confirmar: 'Confirm',
	},

	'es': {
	},
};

module.exports = {
	language
};